import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  userName:string = "";
  currentPassword:string = "";
  newPassword:string = "";
  confirmNewPassword:string = "";
  spinnerOverlay = false;
  constructor(
    private localStorage: LocalStorageService,
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private router:Router) { }

  ngOnInit(): void {
    this.userName = this.localStorage.retrieve("userInfo")["userName"];
  }

  submit() {
    this.spinnerOverlay = true;
    if (this.newPassword == this.confirmNewPassword) {
      let obj = {
        "phoneNumber": this.userName,
        "currentPassword": this.currentPassword,
        "newPassword": this.newPassword
      }
      this.authService.changePassword(obj).subscribe(data => {
        this.openSnackBar(this.translate.instant("passwordChangeSuccess"),'snackBarSuccess');
        this.spinnerOverlay = false;
        this.router.navigate(['']);
      }, error => {
        this.spinnerOverlay = false;
        console.log(error)
        this.openSnackBar(error.error.message, 'snackBarError');
      })
    }
    else {
      this.openSnackBar(this.translate.instant("confirmPasswordMessageError"), 'snackBarError');
    }
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }
}
